import { useCallback } from 'react';
import { ClarityService } from '@services';

export const useClarity = () => {
  const identify = useCallback((customId: string, sessionId?: string, pageId?: string, friendlyName?: string) => {
    ClarityService.identify(customId, sessionId, pageId, friendlyName);
  }, []);

  const setTag = useCallback((key: string, value: string) => {
    ClarityService.setTag(key, value);
  }, []);

  const trackEvent = useCallback((name: string) => {
    ClarityService.event(name);
  }, []);

  const consent = useCallback(() => {
    ClarityService.consent();
  }, []);

  const upgrade = useCallback((reason: string) => {
    ClarityService.upgrade(reason);
  }, []);

  return {
    identify,
    setTag,
    trackEvent,
    consent,
    upgrade
  };
};